export const TEST_USER = {
  id: 6051234,
  address: "0xcb03d1acd17abaf5c6019da30c9e652bdbed459f",
} as const

export const GUILD_CHECKOUT_TEST_GUILD_URL_NAME = "guild-checkout-e2e"
export const GUILD_JOIN_TEST_GUILD_URL_NAME = "guild-join-e2e"

export const TEST_GUILD_URL_NAME = "guild-e2e"
